import { render, staticRenderFns } from "./subRouteView.vue?vue&type=template&id=81a9c048&"
import script from "./subRouteView.vue?vue&type=script&lang=js&"
export * from "./subRouteView.vue?vue&type=script&lang=js&"
import style0 from "./subRouteView.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports